import { render, staticRenderFns } from "./radial.menu.vue?vue&type=template&id=927fd38a&scoped=true&"
import script from "./radial.menu.vue?vue&type=script&lang=js&"
export * from "./radial.menu.vue?vue&type=script&lang=js&"
import style0 from "./radial.menu.vue?vue&type=style&index=0&id=927fd38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927fd38a",
  null
  
)

export default component.exports